import { render, staticRenderFns } from "./EstimationCollection.vue?vue&type=template&id=9edf0158"
import script from "./EstimationCollection.vue?vue&type=script&lang=js"
export * from "./EstimationCollection.vue?vue&type=script&lang=js"
import style0 from "./EstimationCollection.vue?vue&type=style&index=0&id=9edf0158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports